<template>
  <div class="roll">
    <div class="row text-center p-2">
      <div class="col-12 p-0 up">
        <button class="select-button top" @click="prev()">
          <i class="fas fa-chevron-up"></i>
        </button>
      </div>
      <div class="col-12 p-0 display">
        <ul class="list">
          <li :key="key" v-for="(item, key) in rollList" :class="{ selected: item === list[selected] }">{{ item }}</li>
        </ul>
      </div>
      <div class="col-12 p-0 down">
        <button class="select-button bottom" @click="next()">
          <i class="fas fa-chevron-down"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Roll',
  props: ['list', 'selected'],
  mounted () {
    const list = this.$el.querySelectorAll('.list li')
    const deg = [50, 40, 0, -40, 50]
    for (let i = 0; i < list.length; i++) {
      list[i].style.transform = 'rotateX(' + deg[i] + 'deg)'
    }
  },
  methods: {
    next () {
      if (this.list[this.selected + 1] !== undefined) {
        this.$emit('update:selected', this.selected + 1)
      } else {
        this.$emit('update:selected', 0)
      }
    },
    prev () {
      if (this.list[this.selected - 1] !== undefined) {
        this.$emit('update:selected', this.selected - 1)
      } else {
        this.$emit('update:selected', this.list.length - 1)
      }
    }
  },
  computed: {
    rollList () {
      let list = this.list.filter((item, idx) => {
        return idx > this.selected - 3 && idx < this.selected + 3
      })
      if (list.length !== 5) {
        const pos = list.indexOf(this.list[this.selected])
        const missing = 5 - list.length
        if (pos !== 2) {
          list = this.list.slice(this.list.length - missing, this.list.length).concat(list)
        } else {
          list = list.concat(this.list.slice(0, missing))
        }
      }
      return list
    }
  }
}
</script>

